// src/components/VideoPrivacyInfo.js
//
// Infoknop op de pagina's van de video-analyse: opent een pop-up met hoe het zit met privacy.
// De tekst zegt hetzelfde als het A4'tje over privacy bij de video-analyse. Elke bewering klopt
// met de code en productie (opslag in europe-west4, het model in de EU-regio, de e-mailcode van
// acht uur, verwijderen door de gebruiker); verandert er daar iets, dan veranderen deze tekst en het
// A4'tje mee. De bewaartermijn komt uit de backend.
import React, { useState } from 'react';

import InfoModal from './InfoModal';
import useVideoBewaartermijn from '../hooks/useVideoBewaartermijn';

const Leerkracht = () => <>leer<strong>kracht</strong></>;

function PrivacyTekst({ bewaartermijn }) {
  return (
    <>
      <p>Je uploadt een video van je eigen les en kiest een doorloopje als lens. Een AI-model bekijkt en beluistert je video. Het schrijft een rapport over wat jij doet: per stap wat het zag, sterke punten, verbeterpunten en een tijdlijn. Het rapport is alleen voor jou. Er kunnen leerlingen te zien of te horen zijn. Daarom gaan we extra zorgvuldig met je video om.</p>

      <h3>Waar je gegevens staan en worden verwerkt</h3>
      <ul>
        <li>Je video: in een eigen, afgeschermde opslag van Doorloopjes bij Google Cloud in Nederland. De opslag is niet openbaar.</li>
        <li>Je rapport en notities: in de database van Doorloopjes, ook in Nederland.</li>
        <li>De analyse: het AI-model Gemini van Google doet die, op de zakelijke clouddienst van Google binnen de EU. Google traint geen AI-modellen met je video.</li>
        <li>We bewaren geen uitgeschreven tekst van wat er gezegd wordt.</li>
      </ul>

      <h3>Wie erbij kan</h3>
      <p>Niet iedereen heeft de video-analyse. Een beheerder zet hem per account aan. Open je de video-analyse, dan vul je naast je wachtwoord een code in die je per mail krijgt. Met die code kun je acht uur in die browser verder. Alleen jij kunt je video terugkijken en je rapport lezen. Niemand anders met een account ziet je video's en rapporten, ook je school en <Leerkracht /> niet. Je kunt ze ook niet delen.</p>

      <h3>Wat de AI doet</h3>
      <p>Voor de analyse maken we een kleinere kopie van je video. Alleen die kopie gaat naar het AI-model. We verwijderen hem direct na de analyse. Het model schrijft alleen over wat jij doet. Het noemt geen leerlingen bij naam en beschrijft ze niet herkenbaar. Het beoordeelt geen losse leerlingen, maar beschrijft de klas als groep.</p>

      <h3>Wat je zelf kunt kiezen</h3>
      <ul>
        <li>Gezichten onherkenbaar maken. De kopie die de AI krijgt, heeft dan vervaagde gezichten. Je eigen video blijft scherp.</li>
        <li>Alleen het geluid. We maken van je video geluid en verwijderen de video direct. De AI krijgt geen beeld. Je luistert je les dan terug in plaats van hem te bekijken.</li>
      </ul>

      <h3>Bewaren en zelf verwijderen</h3>
      <ul>
        <li>Je kunt een analyse altijd zelf verwijderen, met de knop Verwijderen op de pagina Video Analyse. We verwijderen dan je video, je rapport en je notities.</li>
        {bewaartermijn && (
          <li>Verwijder je niets, dan verwijderen we je video vanzelf {bewaartermijn.woorden} na het uploaden. Je rapport blijft staan. Terugkijken of terugluisteren kan dan niet meer.</li>
        )}
        <li>In onze technische logboeken staan geen beelden en geen inhoud van rapporten.</li>
      </ul>

      <h3>Vragen?</h3>
      <p>Mail naar <a href="mailto:info@doorloopjes.nl">info@doorloopjes.nl</a>. Doorloopjes is van Stichting <Leerkracht />. AI voor Impact bouwt en beheert het voor <Leerkracht />.</p>
    </>
  );
}

function VideoPrivacyInfo() {
  const [open, setOpen] = useState(false);
  // Al bij het tonen van de knop opgehaald, zodat de termijn er is als de pop-up opengaat.
  const bewaartermijn = useVideoBewaartermijn();

  return (
    <>
      <button type="button" className="privacy-info-knop" onClick={() => setOpen(true)} aria-haspopup="dialog">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        Privacy
      </button>
      <InfoModal show={open} onClose={() => setOpen(false)} title="Privacy bij de video-analyse">
        <PrivacyTekst bewaartermijn={bewaartermijn} />
      </InfoModal>
    </>
  );
}

export default VideoPrivacyInfo;
